import { render, staticRenderFns } from "./CandidateForm.vue?vue&type=template&id=7340e7a6&scoped=true&"
import script from "./CandidateForm.vue?vue&type=script&lang=js&"
export * from "./CandidateForm.vue?vue&type=script&lang=js&"
import style0 from "./CandidateForm.vue?vue&type=style&index=0&id=7340e7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7340e7a6",
  null
  
)

export default component.exports